export type PaymentMethod = {
  name: string;
  currency: string;
  icon: string;
  nowPaymentsId: string;
  network: string;
  networkTOSow: string;
  decimals: number;
  minAmount: number;
};

export const networkData = {
  bnb: {
    name: "BNB Smart Chain",
    icon: require("assets/coins/bnb.png"),
  },
  ethereum: {
    name: "Ethereum",
    icon: require("assets/coins/eth.png"),
  },
  tron: {
    name: "Tron",
    icon: require("assets/coins/tron.png"),
  },
  solana: {
    name: "Solana",
    icon: require("assets/coins/sol.png"),
  },
  ton: {
    name: "TON",
    icon: require("assets/coins/ton.png"),
  },
  bitcoin: {
    name: "Bitcoin",
    icon: require("assets/coins/btc.png"),
  },
  base: {
    name: "Base",
    icon: require("assets/coins/base.png"),
  },
};

const MIN_AMOUNTS = {
  BNB: 30,
  BASE: 30,
  ETH: 50,
  TRON: 100,
  BTC: 100,
  SOLANA: 30,
};

const getMinAmount = (currency: string, network: string): number => {
  if (currency === "BNB") return MIN_AMOUNTS.BNB;
  if (currency === "BTC") return MIN_AMOUNTS.BTC;
  if (currency === "ETH") return MIN_AMOUNTS.ETH;
  if (network === "base") return MIN_AMOUNTS.BASE;
  if (network === "tron") return MIN_AMOUNTS.TRON;
  if (network === "solana") return MIN_AMOUNTS.SOLANA;
  return 30;
};

export const paymentMethods: PaymentMethod[] = [
  {
    name: "USD Coin",
    currency: "USDC",
    icon: require("assets/coins/usdc.webp"),
    nowPaymentsId: "USDCBASE",
    network: "base",
    networkTOSow: "Base",
    decimals: 6,
    minAmount: getMinAmount("USDC", "base"),
  },
  {
    name: "USD Coin",
    currency: "USDC",
    icon: require("assets/coins/usdc.webp"),
    nowPaymentsId: "USDCBSC",
    network: "bnb",
    networkTOSow: "BSC",
    decimals: 6,
    minAmount: getMinAmount("USDC", "bnb"),
  },
  {
    name: "USD Coin",
    currency: "USDC",
    icon: require("assets/coins/usdc.webp"),
    nowPaymentsId: "USDCERC20",
    network: "ethereum",
    networkTOSow: "ERC20",
    decimals: 6,
    minAmount: getMinAmount("USDC", "ethereum"),
  },
  {
    name: "USD Coin",
    currency: "USDC",
    icon: require("assets/coins/usdc.webp"),
    nowPaymentsId: "USDCSOL",
    network: "solana",
    networkTOSow: "Solana",
    decimals: 6,
    minAmount: getMinAmount("USDC", "solana"),
  },

  {
    name: "Tether",
    currency: "USDT",
    icon: require("assets/coins/tether.webp"),
    nowPaymentsId: "USDTERC20",
    network: "ethereum",
    networkTOSow: "ERC20",
    decimals: 6,
    minAmount: getMinAmount("USDT", "ethereum"),
  },
  {
    name: "Tether",
    currency: "USDT",
    icon: require("assets/coins/tether.webp"),
    nowPaymentsId: "USDTBSC",
    network: "bnb",
    networkTOSow: "BSC",
    decimals: 6,
    minAmount: getMinAmount("USDT", "bnb"),
  },
  {
    name: "Tether",
    currency: "USDT",
    icon: require("assets/coins/tether.webp"),
    nowPaymentsId: "USDTTRC20",
    network: "tron",
    networkTOSow: "TRC20",
    decimals: 6,
    minAmount: getMinAmount("USDT", "tron"),
  },
  {
    name: "Tether",
    currency: "USDT",
    icon: require("assets/coins/tether.webp"),
    nowPaymentsId: "USDTSOL",
    network: "solana",
    networkTOSow: "Solana",
    decimals: 6,
    minAmount: getMinAmount("USDT", "solana"),
  },
  {
    name: "Tether",
    currency: "USDT",
    icon: require("assets/coins/tether.webp"),
    nowPaymentsId: "USDTTON",
    network: "ton",
    networkTOSow: "TON",
    decimals: 6,
    minAmount: getMinAmount("USDT", "ton"),
  },

  {
    name: "Binance Coin",
    currency: "BNB",
    icon: require("assets/coins/binanceCoin.webp"),
    nowPaymentsId: "BNBBSC",
    network: "bnb",
    networkTOSow: "BSC",
    decimals: 18,
    minAmount: getMinAmount("BNB", "bnb"),
  },
  {
    name: "Bitcoin",
    currency: "BTC",
    icon: require("assets/coins/bitcoin.webp"),
    nowPaymentsId: "BTC",
    network: "bitcoin",
    networkTOSow: "BTC",
    decimals: 8,
    minAmount: getMinAmount("BTC", "bitcoin"),
  },
  {
    name: "Ethereum",
    currency: "ETH",
    icon: require("assets/coins/ethereum.webp"),
    nowPaymentsId: "ETH",
    network: "ethereum",
    networkTOSow: "ERC20",
    decimals: 18,
    minAmount: getMinAmount("ETH", "ethereum"),
  },
  {
    name: "Ethereum",
    currency: "ETH",
    icon: require("assets/coins/ethereum.webp"),
    nowPaymentsId: "ETHBASE",
    network: "base",
    networkTOSow: "BASE",
    decimals: 16,
    minAmount: getMinAmount("ETH", "ethereum"),
  },
  {
    name: "Solana",
    currency: "SOL",
    icon: require("assets/coins/solana.webp"),
    nowPaymentsId: "SOL",
    network: "solana",
    networkTOSow: "Solana",
    decimals: 9,
    minAmount: getMinAmount("SOL", "solana"),
  },
];

export const currencyGroups: {
  [key: string]: { icon: string; name: string; nowPaymentsId: string }[];
} = {
  USDC: [
    {
      icon: networkData.ethereum.icon,
      name: networkData.ethereum.name,
      nowPaymentsId: "USDCERC20",
    },
    {
      icon: networkData.bnb.icon,
      name: networkData.bnb.name,
      nowPaymentsId: "USDCBSC",
    },
    {
      icon: networkData.solana.icon,
      name: networkData.solana.name,
      nowPaymentsId: "USDCSOL",
    },
    {
      icon: networkData.base.icon,
      name: networkData.base.name,
      nowPaymentsId: "USDCBASE",
    },
  ],
  USDT: [
    {
      icon: networkData.ethereum.icon,
      name: networkData.ethereum.name,
      nowPaymentsId: "USDTERC20",
    },
    {
      icon: networkData.bnb.icon,
      name: networkData.bnb.name,
      nowPaymentsId: "USDTBSC",
    },
    {
      icon: networkData.tron.icon,
      name: networkData.tron.name,
      nowPaymentsId: "USDTTRC20",
    },
    {
      icon: networkData.solana.icon,
      name: networkData.solana.name,
      nowPaymentsId: "USDTSOL",
    },
    {
      icon: networkData.ton.icon,
      name: networkData.ton.name,
      nowPaymentsId: "USDTTON",
    },
  ],
  BNB: [{ icon: networkData.bnb.icon, name: "BNB", nowPaymentsId: "BNB" }],
  BTC: [{ icon: networkData.bitcoin.icon, name: "BTC", nowPaymentsId: "BTC" }],
  ETH: [
    { icon: networkData.ethereum.icon, name: "ETH", nowPaymentsId: "ETH" },
    { icon: networkData.base.icon, name: "BASE", nowPaymentsId: "ETHBASE" },
  ],
  SOL: [{ icon: networkData.solana.icon, name: "SOL", nowPaymentsId: "SOL" }],
};

export type NetworkKey = keyof typeof networkData;

export const networkIconMap = paymentMethods.reduce(
  (acc, method) => {
    if (method.network) {
      acc[method.nowPaymentsId] =
        networkData[method.network as NetworkKey].icon;
    }
    return acc;
  },
  {} as Record<string, string>,
);
